import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { Key } from 'readline';

interface Gender {
   
}

interface GenderState {
    data: Gender[];
    loading: boolean;
    error: string | null;
}

const MASTERPORT = import.meta.env.VITE_USERS_PORT;
const MASTERURL = import.meta.env.VITE_API_USERS_URL;

export const fetchGender = createAsyncThunk<Gender[], void, { rejectValue: string }>(
    'Gender/fetchGender',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.get<{ data: Gender[] }>('/get_all_gender', MASTERPORT, MASTERURL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const createGender = createAsyncThunk<Gender, any, { rejectValue: string }>(
    'Gender/createGender',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.post<{ data: Gender }>('create_city', params, MASTERPORT, MASTERURL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);
export const getByIdGender = createAsyncThunk<
    Gender[],
    { id: number | string },
    { rejectValue: string }
>(

    'Gender/getByIdGender',
    async (params, { rejectWithValue }) => {
        try {
            const config = { params };
            const response = await apiService.get<any>('get_by_id_city', MASTERPORT, MASTERURL, config
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.message || 'An error occurred');
        }
    }
);

export const updateGender = createAsyncThunk<Gender, any, { rejectValue: string }>(
    'Gender/updateGender',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.put<{ data: Gender }>('update_city', params, MASTERPORT, MASTERURL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const softDeleteGender: any = createAsyncThunk<
    number,
    number
>(
    "DeleteGender/softDeleteGender",
    async (id,) => {
        try {
            const response = await apiService.patch(
                `soft_delete_city?id=${id}`,
                {},
                MASTERPORT,
                MASTERURL
            );

            return response



        } catch (error: any) {
            return (
                error?.message || "An error occurred while deleting cuisine type"
            );
        }
    }
);

export const GenderSlice = createSlice({
    name: 'Gender',
    initialState: {
        data: [],
        loading: false,
        error: null,
    } as GenderState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchGender.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchGender.fulfilled, (state, action: PayloadAction<Gender[]>) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchGender.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(createGender.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createGender.fulfilled, (state, action: PayloadAction<Gender>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(createGender.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(getByIdGender.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getByIdGender.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(getByIdGender.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to load cities';
            })
            .addCase(updateGender.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateGender.fulfilled, (state, action: PayloadAction<Gender>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(updateGender.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
    },
});

export default GenderSlice.reducer;